<div class="main">
    <h2 translate>home.lblLocalAgentsManagement</h2>
    <div class="dx-fieldset">
        <dx-data-grid keyExpr="id"
                      hoverStateEnabled="true"
                      [columnAutoWidth]="true"
                      [dataSource]="localAgents"
                      [height]="250"
                      [showColumnHeaders]="false"
                      [showColumnLines]="false"
                      [wordWrapEnabled]="true"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)">
            <dxo-scrolling showScrollbar="always"></dxo-scrolling>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxi-column dataField="environmentName" [caption]="'home.lblEnvironment' | translate" [groupIndex]="0"></dxi-column>
            <dxi-column dataField="displayName" [caption]="'home.lblLocalAgent' | translate"></dxi-column>
            <dxi-column dataField="currentStatus" [caption]="'localAgents.lblStatus' | translate" [calculateCellValue]="displayStatus"></dxi-column>
        </dx-data-grid>
    </div>
</div>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
